import { v4 as uuidv4 } from "uuid";
import { LomdaV3Page } from "@/lib/utils/lomdaV3/types";

/** Nested lists: the `gap-2` between blocks and each block frame's `p-1.5`. */
export const NESTED_GAP_PX = 8;
export const NESTED_FRAME_PADDING_PX = 6;

export const createEmptyPage = (order: number): LomdaV3Page => ({
    id: uuidv4(),
    order,
    title: "",
    blocks: [],
});
